// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Md2qZ","controls":"styles_controls__3iaoj","charLimit":"styles_charLimit__dC62a","input":"styles_input__1v_Et","send":"styles_send__36aPQ"};